// List of bikes supported by Hold My Throttle.
// Each entry maps a bike to its firmware .hex file that lives in
// /public/firmware/. To add or update a bike, edit this list.
//
// `file` is fetched relative to the site root, so the corresponding
// hex file must exist at: /public/firmware/<file>

export const BIKES = [
    { id: "ktm-390", name: "KTM 390 2020+", file: "ktm-390.hex" },
    { id: "ktm-390-2017", name: "KTM 390 (2017+)", file: "ktm-390-2017.hex" },
    { id: "triumph-400", name: "Triumph 400", file: "triumph-400.hex" },
    { id: "triumph-660-765", name: "Triumph 660/765", file: "triumph-660-765.hex" },
    { id: "triumph-900", name: "Triumph 900", file: "triumph-900.hex" },
    { id: "bajaj-400", name: "Bajaj 400", file: "bajaj-400.hex" },
    { id: "suzuki-800", name: "Suzuki 800", file: "suzuki-800.hex" },
    { id: "suzuki-1000", name: "Suzuki 1000 (GSX / Katana)", file: "suzuki-1000.hex" },
    { id: "re-450", name: "Royal Enfield 450", file: "re-450.hex" },
    { id: "aprilia-457", name: "Aprilia 457", file: "aprilia-457.hex" },
    { id: "bmw-457", name: "BMW 310", file: "bmw-310.hex" },
    { id: "bmw-310-north-america-only", name: "BMW 310 North America Only", file: "bmw-310-north-america-only.hex" },
    { id: "honda-750", name: "Honda Transalp 750", file: "honda-750.hex" },
    { id: "led-test", name: "Button Test", file: "LED-TEST.hex" },
];

export function getBikeById(id) {
    return BIKES.find((b) => b.id === id) || null;
}
